export default "__VITE_ASSET__87f6bb1e__"